import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { Select } from 'antd';
import { getPanelMaxWidth, getPanelMaxHeight } from '@/services/helper/panelSizeHelper';
import { IMPEDANCE_SOCKET } from '../../../services/Cascade/constants';

const { Option, OptGroup } = Select;
class AddModelPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: 800,
      maxHeight: 1000,
      layoutType: "",
      pcbList: [],
    };
    this.dialogRoot = document.getElementById('root');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 800),
      maxHeight: getPanelMaxHeight(offset, 1000),
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  closeModal = () => {
    const { layoutType } = this.state;
    if (layoutType) {
      this.props.createModel(layoutType)
    }
    this.props.closeModal(false)
  }

  pcbSelect = (layoutType) => {
    this.setState({
      layoutType
    })
  }

  timeResize = () => {
    setTimeout(() => {
      this.resize()
    }, 1000)
  }

  modelSelectRender = () => {
    const { layoutType } = this.state;
    return (
      <div className="cascade-switch-pcb-content">
        <span className="font-bold cascade-setup-title-color-only">Socket</span>
        <Select
          value={layoutType}
          onChange={this.pcbSelect}
          getPopupContainer={(() => document.getElementById('root'))}
          showSearch={true}
          className="pcb-select"
          popupClassName="aurora-select-dropdown"
        >
          <OptGroup label='Socket'>
            <Option key={IMPEDANCE_SOCKET} title={IMPEDANCE_SOCKET} value={IMPEDANCE_SOCKET}>Socket</Option>
          </OptGroup>
          {/* <OptGroup label='Interposer'>
            <Option key={IMPEDANCE_INTERPOSER} title={hasDie ? IMPEDANCE_INTERPOSER : 'Please add die first.'} value={IMPEDANCE_INTERPOSER} disabled={!hasPackage || !hasDie || hasInterposer}>Interposer</Option>
          </OptGroup> */}
        </Select>
      </div>
    );
  }

  render() {
    const { maxHeight, maxWidth } = this.state
    const content = (
      <Fragment>
        <Panel
          className='cascade-add-pcb-panel'
          title={'Add Model'}
          onCancel={this.closeModal}
          zIndex={2000}
          width={500}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          position='panel-center-left'
          draggable
          minHeight={300}
          minWidth={200}
          resizeEnd={this.timeResize}
        >
          {this.modelSelectRender()}
        </Panel>
        <div id="cascade-add-connection-dialog"></div>
      </Fragment>
    )
    return createPortal(content, this.dialogRoot);
  }
};

export default AddModelPanel;
